'use client'

import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Heading, Text } from '@/components/ui/typography'

interface PhoneConfirmDialogProps {
  isOpen: boolean
  onCloseAction: () => void
  phoneNumber: string
  onConfirmAction: () => void
  onUseDifferentPhoneAction: () => void
  isLoading?: boolean
}

export const PhoneConfirmDialog = ({
  isOpen,
  onCloseAction,
  phoneNumber,
  onConfirmAction,
  onUseDifferentPhoneAction,
  isLoading = false,
}: PhoneConfirmDialogProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onCloseAction}>
      <DialogContent className='sm:max-w-md'>
        <DialogHeader className='text-center'>
          <DialogTitle asChild>
            <Heading variant='heading5' className='text-neutral-900'>
              Xác nhận số điện thoại
            </Heading>
          </DialogTitle>
        </DialogHeader>

        <div className='space-y-6 py-4'>
          <Text variant='body2' className='text-center text-neutral-600'>
            Bạn dùng số điện thoại{' '}
            <span className='font-semibold text-neutral-900'>
              {phoneNumber}
            </span>{' '}
            này đăng nhập
          </Text>

          <div className='flex gap-3'>
            <Button
              variant='outline'
              className='flex-1'
              onClick={onUseDifferentPhoneAction}
              disabled={isLoading}
            >
              Số khác
            </Button>
            <Button
              variant='primary'
              className='flex-1'
              onClick={onConfirmAction}
              loading={isLoading}
            >
              Đúng
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
